/**
 * Widget checkout shop key: a publishable key (pk_live_…) the merchant puts in
 * their store's page so the widget can start a payment from a cart of price
 * IDs. It can only create payments that pay this merchant.
 */

import { adminFetch } from "./api";

export interface CheckoutKey {
  object: "checkout_key";
  publishable_key: string;
  /** Websites allowed to use the key. Empty means any website. */
  allowed_origins: string[];
  /** The page may start a checkout from a cart of price IDs. */
  client_prices: boolean;
}

/** Read the shop key (the server creates it on first read). */
export const getCheckoutKey = (): Promise<CheckoutKey> =>
  adminFetch<CheckoutKey>("/api/admin/checkout_key");

/** Replace the shop key. The old one stops working right away. */
export const rotateCheckoutKey = (): Promise<CheckoutKey> =>
  adminFetch<CheckoutKey>("/api/admin/checkout_key/rotate", { method: "POST" });

/** Set the websites allowed to use the key ([] allows any website). */
export const setCheckoutOrigins = (origins: string[]): Promise<{ allowed_origins: string[] }> =>
  adminFetch("/api/admin/checkout_key/origins", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ origins }),
  });
